import './fontawesome';
import './i18n';
import './yup';
export * from './theme';